import { isMac } from 'shared/lib/deviceDetector'

export const getLastStepHintMessage = (firstPart: string[]) => {
  return isMac
    ? [...firstPart, '⌘Enter to submit', 'Esc to skip']
    : [...firstPart, 'Ctrl Enter to submit', 'Esc to skip']
}
